// import one from '../assets/jpg/landingPage.jpg'
// import two from '../assets/svg/projects/two.svg'
// import three from '../assets/svg/projects/three.svg'
// import four from '../assets/svg/projects/four.svg'
// import five from '../assets/svg/projects/five.svg'
// import six from '../assets/svg/projects/six.svg'
// import seven from '../assets/svg/projects/seven.svg'
// import eight from '../assets/svg/projects/eight.svg'



export const projectsData = [
    
    {
        id: 1,
        projectName: 'Pet Store',
        projectDesc: 'It is a website application for adding pet supplies.',
        tags: ['Ruby', 'Ruby on Rails'],
        code: 'https://github.com/tarek102/rails_pet_shop',
        demo: 'https://rails-pet-shop.onrender.com/',
        image: 'https://ik.imagekit.io/4t6ufpirwu/Capture.PNG?ik-sdk-version=javascript-1.4.3&updatedAt=1674039529879'
    },
    
    {
        id: 2,
        projectName: 'Crypto currencies',
        projectDesc: 'A web application that displays information about popular cryptocurrencies and was built using the Binance API',
        tags: ['JavaScript', 'React', 'Redux'],
        code: 'https://github.com/tarek102/react-capstone-project-financial-modeling',
        demo: 'https://taupe-genie-b9016f.netlify.app/',
        image: 'https://ik.imagekit.io/4t6ufpirwu/Capture3.PNG?ik-sdk-version=javascript-1.4.3&updatedAt=1674122687605'
    },
    {
        id: 3,
        projectName: 'Movie web app',
        projectDesc: 'An online application that lists movies and provides information about each one',
        tags: ['Webpack', 'API', 'JavaScript', 'HTML', 'CSS'],
        code: 'https://github.com/tarek102/JavaScript-capstone',
        demo: 'https://tarek102.github.io/JavaScript-capstone/dist/',
        image: 'https://ik.imagekit.io/4t6ufpirwu/movie.PNG?ik-sdk-version=javascript-1.4.3&updatedAt=1674041207945'
    },
   
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/